import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import authService from '../../services/authService'

interface RoleProtectedRouteProps {
  children: React.ReactNode
  allowedRoles: string[]
}

const RoleProtectedRoute: React.FC<RoleProtectedRouteProps> = ({
  children,
  allowedRoles
}) => {
  const currentUser = authService.getCurrentUser()
  console.log(currentUser)

  if (!currentUser || !allowedRoles.includes(currentUser.role)) {
    return (
      <div className='flex flex-col items-center justify-center min-h-screen bg-gray-100'>
        <h1 className='text-6xl font-bold text-gray-800'>403</h1>
        <p className='mb-6 text-xl text-gray-600'>
          Bạn không có quyền truy cập trang này
        </p>
        <a
          href='/admin/dashboard'
          className='px-4 py-2 text-white bg-green-600 rounded hover:bg-green-700'
        >
          Quay lại trang chủ
        </a>
      </div>
    )
  }

  return <>{children}</>
}

export default RoleProtectedRoute
